import { createFileRoute } from '@tanstack/react-router'
import { ReportsCatalog } from '@/features/reports/reports-catalog'
import { requirePermission } from '@/lib/route-guards'

/** Catálogo de reportes. */
export const Route = createFileRoute('/_app/reports/')({
  beforeLoad: requirePermission('reports:read'),
  component: ReportsCatalog,
})
